import { render } from "./CompanyQRAttendanceDataTable.vue?vue&type=template&id=63b4575c&scoped=true"
import script from "./CompanyQRAttendanceDataTable.vue?vue&type=script&lang=js"
export * from "./CompanyQRAttendanceDataTable.vue?vue&type=script&lang=js"

import "./CompanyQRAttendanceDataTable.vue?vue&type=style&index=0&id=63b4575c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b4575c"]])

export default __exports__